export const environment = {
  production: true,
  apiHost: "https://api.mediamonorail.com",
  signInUrl: "https://api.mediamonorail.com/authorize",
  connectUrl: "https://mediamonorail.com/assets/connect/v4",
  version: require('../../package.json').version,
  monorailV4URL: "https://v4.mediamonorail.com",
  datadogRumEnv: "prod"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts